import { LocalVariablesSync } from './local-variables-sync';

/**
 * Adds local variables to exception frames
 */
export const LocalVariables = LocalVariablesSync;
